// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"S2YNR3dY","h1":"xTwzolJk","h2":"_0tG0UsAi","btn":"uzkVeuTW"};